module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ext-form', {
    attrs: {
      "formData": _vm.formData,
      "submitProxy": _vm.submitProxy,
      "loadProxy": _vm.loadProxy,
      "submitBtnText": "Создать"
    }
  }, [_c('b-form-fieldset', {
    attrs: {
      "label": "Роль"
    }
  }, [_c('combo-box', {
    attrs: {
      "options": "api/role"
    },
    model: {
      value: (_vm.formData.role_id),
      callback: function($$v) {
        _vm.formData.role_id = $$v
      },
      expression: "formData.role_id"
    }
  })], 1), _vm._v(" "), _c('b-form-fieldset', {
    class: {
      'is-invalid': _vm.errors.has('login')
    },
    attrs: {
      "label": "Логин",
      "feedback": _vm.errors.first('login')
    }
  }, [_c('input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required|eng'),
      expression: "'required|eng'"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.formData.login),
      expression: "formData.login"
    }],
    staticClass: "form-control",
    attrs: {
      "name": "login"
    },
    domProps: {
      "value": (_vm.formData.login)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.formData.login = $event.target.value
      }
    }
  })]), _vm._v(" "), (!this.loadProxy) ? _c('b-form-fieldset', {
    class: {
      'is-invalid': _vm.errors.has('password')
    },
    attrs: {
      "label": "Пароль",
      "feedback": _vm.errors.first('password')
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.formData.password),
      expression: "formData.password"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "password",
      "name": "password"
    },
    domProps: {
      "value": (_vm.formData.password)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.formData.password = $event.target.value
      }
    }
  })]) : _vm._e(), _vm._v(" "), _c('b-form-fieldset', {
    class: {
      'is-invalid': _vm.errors.has('name')
    },
    attrs: {
      "label": "Имя",
      "feedback": _vm.errors.first('name')
    }
  }, [_c('input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('letters_only'),
      expression: "'letters_only'"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.formData.name),
      expression: "formData.name"
    }],
    staticClass: "form-control",
    attrs: {
      "name": "name"
    },
    domProps: {
      "value": (_vm.formData.name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.formData.name = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('b-form-fieldset', {
    class: {
      'is-invalid': _vm.errors.has('surname')
    },
    attrs: {
      "label": "Фамилия",
      "feedback": _vm.errors.first('surname')
    }
  }, [_c('input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('letters_only'),
      expression: "'letters_only'"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.formData.surname),
      expression: "formData.surname"
    }],
    staticClass: "form-control",
    attrs: {
      "name": "surname"
    },
    domProps: {
      "value": (_vm.formData.surname)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.formData.surname = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('b-form-fieldset', {
    class: {
      'is-invalid': _vm.errors.has('patronymic')
    },
    attrs: {
      "label": "Отчество",
      "feedback": _vm.errors.first('patronymic')
    }
  }, [_c('input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('letters_only'),
      expression: "'letters_only'"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.formData.patronymic),
      expression: "formData.patronymic"
    }],
    staticClass: "form-control",
    attrs: {
      "name": "patronymic"
    },
    domProps: {
      "value": (_vm.formData.patronymic)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.formData.patronymic = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('b-form-fieldset', {
    class: {
      'is-invalid': _vm.errors.has('birthdate')
    },
    attrs: {
      "label": "Дата рождения",
      "feedback": _vm.errors.first('birthdate')
    }
  }, [_c('InlineDatepicker', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required|date'),
      expression: "'required|date'"
    }],
    attrs: {
      "name": "birthdate"
    },
    model: {
      value: (_vm.formData.birthdate),
      callback: function($$v) {
        _vm.formData.birthdate = $$v
      },
      expression: "formData.birthdate"
    }
  })], 1), _vm._v(" "), _c('b-form-fieldset', {
    class: {
      'is-invalid': _vm.errors.has('email')
    },
    attrs: {
      "label": "Email",
      "feedback": _vm.errors.first('email')
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.trim.lazy",
      value: (_vm.formData.email),
      expression: "formData.email",
      modifiers: {
        "trim": true,
        "lazy": true
      }
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('email'),
      expression: "'email'"
    }],
    staticClass: "form-control",
    attrs: {
      "name": "email"
    },
    domProps: {
      "value": (_vm.formData.email)
    },
    on: {
      "change": function($event) {
        _vm.formData.email = $event.target.value.trim()
      },
      "blur": function($event) {
        _vm.$forceUpdate()
      }
    }
  })]), _vm._v(" "), _c('b-form-fieldset', {
    class: {
      'is-invalid': _vm.errors.has('tel')
    },
    attrs: {
      "label": "Контактный телефон",
      "feedback": _vm.errors.first('tel')
    }
  }, [_c('input', {
    directives: [{
      name: "mask",
      rawName: "v-mask",
      value: ('+7 (###) ###-##-##'),
      expression: "'+7 (###) ###-##-##'"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.formData.tel),
      expression: "formData.tel"
    }],
    staticClass: "form-control",
    attrs: {
      "name": "tel"
    },
    domProps: {
      "value": (_vm.formData.tel)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.formData.tel = $event.target.value
      }
    }
  })])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-522d4d28"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/forms/FullAccountForm.vue
// module id = 230
// module chunks = 1